<template>
  <div class="container">
    <Modal :title="modalTitle" :show="modalVisible" @hideModal="hideModal" @submit="hideModal">
      <div class="announcement-modal-body">
        <p>近期公司接到群众反馈，有不法分子通过社交媒体平台冒用我司名义发布虚假信息。为打击违法犯罪行为，避免广大用户利益受损，公司特此澄清如下：</p>
        <p>1、我司从未在网站或社交媒体平台上以任何形式发布过“做任务赢取奖励”或类似信息，也未曾授权任何机构或个人实施此类行为。</p>
        <p>2、广大互联网用户应提高防骗意识，识别互联网上的虚假信息或诈骗信息，拒绝向陌生人透露个人信息及银行、财务信息。</p>
        <p>3、针对盗用我司名义在网上发布虚假信息或实施诈骗的行为，我司将依法追究相关人员的法律责任，积极维护网络环境，保护自身及广大用户权益。</p>
        <p>4、提醒广大用户通过我司官方渠道（官方网站、官方APP、官方微信公众号等）了解招聘信息、业务合作等事宜。如有自称我司员工的人员联系您，可拨打我司官方客服电话进行确认。请勿轻易点击来源不明的链接或下载不明来源的文件，以防感染病毒或泄露个人信息。</p>
        <p>如发现任何可疑行为或接到可疑电话、信息，请及时向当地公安机关报案，并将相关线索提供给我司。</p>
        <p>再次感谢广大用户对我司的信任与支持。我们将一如既往地为您提供优质、安全、可靠的服务。</p>
        <p>&nbsp;</p>
        <p style="text-align: right;">优矩互动（北京）科技有限公司</p>
        <p style="text-align: right;">2024年6月7日</p>
      </div>
    </Modal>
        <div class="page-header">
            <div class="center">
                <div class="logo">
                    <a href="/">
                        <img src="../../static/logo.png" />
                    </a>
                </div>
                <div class="nav">
                    <div class="link">
                        <a :class="$route.path === item.path?'on':''"  v-for="(item,index) in languageNav[language]" :key="index" :href="item.path">{{item.name}}</a>
                    </div>
                    <div class="language">
                        <b :class="language==='ch'?'on':''" @click="setLanguage('ch')">简</b>/
                        <b :class="language==='hk'?'on':''" @click="setLanguage('hk')">繁</b>/
                        <b :class="language==='en'?'on':''" @click="setLanguage('en')">English</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-header">
            <div class="meun-btn" @click="showMobileNav"></div>
            <a href="/logo">
                <img src="../../static/logo.png" />
            </a>
        </div>
        <div class="show-menu" v-if="mobileNav">
            <div class="show-menu-bg" @click="closeMobileNav"></div>
            <div class="menu-box">
                <div class="link">
                    <a v-for="(item,index) in languageNav[language]" :key="index" :href="item.path">{{item.name}}</a>
                </div>
                <div class="language">
                    <b :class="language==='ch'?'on':''" @click="setLanguage('ch')">简</b>
                    <b :class="language==='hk'?'on':''" @click="setLanguage('hk')">繁</b>
                    <b :class="language==='en'?'on':''" @click="setLanguage('en')">English</b>
                </div>
            </div>
        </div>
        <router-view :language="language" ref="routerView" />
        <div class="copyright">
            <div class="center">
            Copyrights © 2023. 优矩互动版权所有 <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2021003454号-3</a>
            </div>
        </div>
        <div class="gotop" @click="goTop"></div>
  </div>
</template>
<script>
import Modal from '../components/Modal.vue'
const setWithExpiry = (key, value, ttl) => {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl
  }
  localStorage.setItem(key, JSON.stringify(item))
}
const getWithExpiry = key => {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}
const isModalVisible = () => {
  const modalVisible = getWithExpiry('modalVisible')
  if (modalVisible === null) {
    setWithExpiry('modalVisible', true, 1000 * 60 * 60 * 24 * 14)
    return true
  }
  return false
}

export default {
  components: {
    Modal
  },
  data () {
    return {
      modalTitle: '警惕网络诈骗，保护个人信息安全',
      modalVisible: isModalVisible(),
      language: this.$cookies.get('websiteLanguage') || 'ch',
      languageNav: {
        'ch': [{
          name: '首页',
          path: '/'
        }, {
          name: '投资者关系',
          path: '/investor'
        }],
        'hk': [{
          name: '首頁',
          path: '/'
        }, {
          name: '投資者關係',
          path: '/investor'
        }],
        'en': [{
          name: 'Home',
          path: '/'
        }, {
          name: 'Investor relations',
          path: '/investor'
        }]
      },
      mobileNav: false
    }
  },
  methods: {
    hideModal () {
        this.modalVisible = false
    },
    setLanguage (val) {
      this.language = val
      this.$cookies.set('websiteLanguage', val)
      this.$refs.routerView.getLanguage(val)
      this.mobileNav = false
    },
    showMobileNav () {
      this.mobileNav = true
    },
    closeMobileNav () {
      this.mobileNav = false
    },
    goTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style>
*{
    padding: 0;
    margin: 0;
}
a{
    text-decoration: none;
}
body{
    min-width: 1200px;
    overflow-x: auto;
    margin: 0;
    padding: 0;
    font-family: 'PingFangSC-Regular', 'helvetica neue', tahoma, 'PingFang SC', 'microsoft yahei', arial, 'hiragino sans gb', sans-serif;
}
.container{
    padding: 0;
    margin: 0;
}
.page-header{
    display: block;
    height: 80px;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99;
    box-shadow: 0 -17px 20px #000;
}
.page{
    margin-top: 80px;
}
.center{
    width: 1200px;
    margin: 0 auto;
}
.logo{
    float: left;
}
.logo a{
    display: block;
    overflow: hidden;
    padding:20px 0 0;
}
.logo a img{
    width: 139px;
}
.nav{
    float: right;
}
.link{
    float: left;
    line-height: 80px;
}
.link a{
    float: left;
    color: #333333;
    font-size: 16px;
    margin:0 25px;
}
.link a.on{
    line-height: 50px;
    margin-top: 15px;
    border-bottom: 3px solid #D70C18;
}
.language{
    float: right;
    background: url('../../static/investor/language.png') no-repeat left center;
    padding-left: 30px;
    margin-left: 35px;
    line-height: 80px;
    color: #666;
    background-size: 18px;
}
.language b{
    display: inline;
    font-weight: normal;
    font-size: 16px;
    color: #666;
    margin-right: 3px;
    cursor: pointer;
}
.language b.on{
    font-weight: bold;
    color: #333;
}
.left{
    float: left;
}
.right{
    float: right;
}
.copyright{
    display: block;
    background: #fff;
    font-size: 14px;
    color: #333333;
    text-align: center;
    line-height: 90px;
}
.copyright a{
    color: #333333;
    text-decoration: underline;
}
.mobile-header{
    display: none;
}
.gotop{
    display: none;
}
p{-webkit-text-size-adjust: none !important;}
@media screen and (max-width: 750px) {
    .show-menu{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0,0,0, 0.3);
        z-index: 100;
    }
    .show-menu-bg{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
        background: rgba(0,0,0, 0.3);
    }
    .menu-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 560px;
        height: 100%;
        background: #fff;
        z-index: 2;
    }
    .link{
        padding: 42px 0;
    }
    .link a{
        line-height: 115px;
        width: 560px;
        text-indent: 80px;
        font-size: 32px;
    }
    .language{
        position:absolute;
        left: 50px;
        width: 460px;
        bottom: 150px;
        border: 1px solid #D8D8D8;
        height: 70px;
        border-radius: 35px;
        margin: 0;
        padding: 0;
        background: none;
    }
    .language b{
        float: left;
        width: 129px;
        text-align: center;
        line-height: 70px;
        color: #666666;
        font-size: 32px;
        margin: 0;
        border-right: 1px solid #D8D8D8;
    }
    .language b.on{
        color: #333333;
    }
    .language b:nth-child(3){
        width: 200px;
        border-right: 0;
    }
    .mobile-header{
        display: block;
        background: #fff;
        height: 110px;
        position:fixed;
        left: 0;
        top: 0;
        width: 750px;
        z-index: 99;
    }
    .meun-btn{
        float: left;
        width: 65px;
        height: 110px;
        margin-left: 20px;
        background: url('../../static/investor/mean.png') no-repeat center center;
        background-size: 35px 31px;
    }
    .mobile-header a{
        display: block;
        width: 139px;
        height: 50px;
        margin:30px 0 0 305px;
    }
    .mobile-header a img{
        width: 139px;
        height: 50px;
    }
    body {
        width: 750px;
        min-width: auto;
    }
    .page-header{
        display: none;
    }
    .center{
        width: 750px;
        margin: 0 auto;
    }
    .copyright{
        width: 750px;
        padding: 20px 0  50px;
    }
    .copyright .center{
        width: 430px;
        font-size: 24px;
        line-height: 48px;
    }
    .gotop{
        display: block;
        position:fixed;
        z-index: 80;
        width: 88px;
        height: 88px;
        right:25px;
        bottom: 60px;
        background: #FAFAFA url('../../static/investor/gotop.png') no-repeat right bottom;
        background-size: 88px 88px;

    }
}

.announcement-modal-body {
  line-height: 1.6;
  text-indent: 2em;
}

.announcement-modal-body p {
  &:not(:last-child) {
    margin-bottom: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/App.vue